import { ParsedTransaction } from '@olxeu-a2b/ui/typings/transaction';
import { TransactionsStore, TransactionType, TransactionsReducer } from './useTransactions.d';
import {
  NEXT_TRANSACTIONS_PAGE,
  PREVIOUS_TRANSACTIONS_PAGE,
  LOADING_TRANSACTIONS,
  SET_TRANSACTIONS_PAGE,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_ERROR,
  SET_ORDER_REJECTED,
  SET_CONTRACT_CANCELLED,
  LAST_TRANSACTIONS_REACHED,
  CLEAR_TRANSACTIONS,
  CLEAR_ACTIVE_TRANSACTION,
  GET_ACTIVE_TRANSACTION_ERROR,
  GET_ACTIVE_TRANSACTION_SUCCESS,
  LOADING_ACTIVE_TRANSACTION,
} from './transactionsActions';
import { ORDER_STATUS } from '../../constants';

export const firstState: TransactionsStore = {
  activeTransaction: null,
  transactions: null,
  allTransactionsLoaded: false,
  loading: false,
  page: 0,
  error: null,
};

const buildTransactionReducer =
  (transactionType: TransactionType): TransactionsReducer =>
    (state, { type, payload }) => {
      switch (type) {
      case LAST_TRANSACTIONS_REACHED(transactionType):
        return { ...state, allTransactionsLoaded: true };

      case LOADING_ACTIVE_TRANSACTION:
      case LOADING_TRANSACTIONS(transactionType):
        return { ...state, loading: true };

      case NEXT_TRANSACTIONS_PAGE(transactionType):
        return { ...state, page: state.page + 1 };

      case PREVIOUS_TRANSACTIONS_PAGE(transactionType):
        return { ...state, page: state.page - 1 };

      case SET_TRANSACTIONS_PAGE(transactionType):
        return { ...state, page: payload as number };

      case GET_ACTIVE_TRANSACTION_SUCCESS:
        return {
          ...state,
          error: null,
          loading: false,
          activeTransaction: payload as ParsedTransaction,
        };

      case GET_TRANSACTIONS_SUCCESS(transactionType): {
        const { transactions } = state;
        const nextPage = payload as ParsedTransaction[];

        return {
          ...state,
          loading: false,
          error: null,
          transactions: transactions ? [...transactions, ...nextPage] : nextPage,
        };
      }

      case GET_ACTIVE_TRANSACTION_ERROR:
        return { ...state, loading: false, error: payload as Error };

      case GET_TRANSACTIONS_ERROR(transactionType):
        return { ...state, loading: false, error: payload as Error };

      case SET_ORDER_REJECTED(transactionType): {
        const { orderId, active } = payload;
        if (active) {
          return {
            ...state,
            activeTransaction: {
              ...state.activeTransaction,
              status: ORDER_STATUS.ORDER_REJECTED,
            },
          };
        }

        const result: ParsedTransaction[] = state.transactions.map(
          (transaction: ParsedTransaction) => {
            if (transaction.order.id === orderId) {
              return { ...transaction, status: ORDER_STATUS.ORDER_REJECTED };
            }
            return transaction;
          },
        );

        return { ...state, transactions: result };
      }

      case SET_CONTRACT_CANCELLED(transactionType): {
        const { orderId, active } = payload;
        if (active) {
          return {
            ...state,
            activeTransaction: {
              ...state.activeTransaction,
              status: ORDER_STATUS.CONTRACT_CANCELLED,
            },
          };
        }

        const result: ParsedTransaction[] = state.transactions.map(
          (transaction: ParsedTransaction) => {
            if (transaction.order.id === orderId) {
              return { ...transaction, status: ORDER_STATUS.CONTRACT_CANCELLED };
            }
            return transaction;
          },
        );

        return { ...state, transactions: result };
      }

      case CLEAR_ACTIVE_TRANSACTION:
        return { ...state, activeTransaction: null };

      case CLEAR_TRANSACTIONS(transactionType):
        return {
          ...state,
          transactions: null,
          allTransactionsLoaded: false,
          loading: false,
          error: null,
          page: 0,
        };

      default:
        return state;
      }
    };

export default buildTransactionReducer;
